import {Injectable} from '@angular/core';
import {User} from '../_models/user';
import {ModalController} from '@ionic/angular';
import {ConfirmEmailComponent} from '../_components/confirm-email/confirm-email.component';
import {UserService} from './user.service';
import {AuthenticationService} from './authentication.service';

@Injectable({
    providedIn: 'root'
})
export class ConfirmEmailService {
    confirmingEmail = false;
    user: User;

    constructor(
        private userService: UserService,
        private authenticationService: AuthenticationService,
        private modalController: ModalController
    ) {
        this.userService.current.subscribe(async u => {
            this.user = !!u ? new User(u) : null;
            if (!this.confirmingEmail && !!this.user && !!this.user.login && !this.user.login.confirmedEmail) {
                this.confirmingEmail = true;
                await this.openConfirmEmail();
            }
        });
    }

    async openConfirmEmail() {
        const modal = await this.modalController.create({
            component: ConfirmEmailComponent
        });

        await modal.present();

        const dataReturned = await modal.onDidDismiss();
        if (!!dataReturned && !!dataReturned.data) {
            this.confirmingEmail = false;
            if (dataReturned.data === 'CANCEL') {
                await this.authenticationService.logout(false);
            }
        } else {
            await this.openConfirmEmail();
        }
    }
}
